import { ApiProjectSettingKey } from "@incendium/api";
import type { TProjectSettings } from "Hooks";
import type {
  ConsentCapture,
  ConsentEnforcement,
  NoConsentBehavior,
} from "./types";

export function parseConsentCapture(raw?: string): ConsentCapture {
  return raw === "manual" ? "manual" : "auto";
}

export function parseConsentEnforcement(raw?: string): ConsentEnforcement {
  return raw === "require" ? "require" : "do_not_require";
}

export function parseNoConsentBehavior(raw?: string): NoConsentBehavior {
  if (raw === "no_tracking") {
    return "no_tracking";
  }
  if (raw === "anonymised" || raw === "anon") {
    return "anonymised";
  }
  return "full";
}

export function readConsentFromProjectSettings(
  projectSettings: TProjectSettings,
): {
  capture: ConsentCapture;
  enforcement: ConsentEnforcement;
  noConsent: NoConsentBehavior;
} {
  return {
    capture: parseConsentCapture(
      projectSettings[ApiProjectSettingKey.CONSENT_CAPTURE],
    ),
    enforcement: parseConsentEnforcement(
      projectSettings[ApiProjectSettingKey.CONSENT_ENFORCEMENT],
    ),
    noConsent: parseNoConsentBehavior(
      projectSettings[ApiProjectSettingKey.NO_CONSENT_BEHAVIOR],
    ),
  };
}

export function writeConsentToProjectSettings(
  draft: TProjectSettings,
  values: {
    capture: ConsentCapture;
    enforcement: ConsentEnforcement;
    noConsent: NoConsentBehavior;
  },
): void {
  draft[ApiProjectSettingKey.CONSENT_CAPTURE] = values.capture;
  draft[ApiProjectSettingKey.CONSENT_ENFORCEMENT] = values.enforcement;
  draft[ApiProjectSettingKey.NO_CONSENT_BEHAVIOR] = values.noConsent;
}
